export type Office = {
  id: string
  officeCode: null | string
  territorialDirectoryCode: null | string
  territorialDirectoryDesc: null | string
  officeName: null | string
  street: null | string
}
